import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function TopNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthed = !!localStorage.getItem('token');

  const go = (path) => navigate(path);

  const current = (path) => (location.pathname === path ? 'page' : undefined);

  return (
    <div className="ui-topnav">
      <div className="ui-topnav-inner">
        <div className="ui-brand" role="button" tabIndex={0} onClick={() => go(isAuthed ? '/home' : '/login')} onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') go(isAuthed ? '/home' : '/login');
        }}>
          <img
            src={`${process.env.PUBLIC_URL}/logo_sharemyride.png`}
            alt="ShareMyRide"
          />
          <div className="ui-brand-title">Share My Ride</div>
        </div>

        {isAuthed && (
          <div className="ui-navlinks" aria-label="Primary navigation">
            <button className="ui-linkbtn" aria-current={current('/home')} onClick={() => go('/home')}>
              Home
            </button>
            <button className="ui-linkbtn" aria-current={current('/Add_Ride')} onClick={() => go('/Add_Ride')}>
              Add ride
            </button>
            <button className="ui-linkbtn" aria-current={current('/my-rides')} onClick={() => go('/my-rides')}>
              My rides
            </button>
            <button className="ui-linkbtn" aria-current={current('/profile')} onClick={() => go('/profile')}>
              Profile
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopNav;

